import {Box, FormControl, InputLabel, MenuItem, Typography} from "@mui/material";
import Select, {SelectChangeEvent} from '@mui/material/Select';
import React, {useState} from "react";
import formulas from "../../../services/formulas";

export default function BestMixNitrox() {

    const {calcBestMixNitrox} = formulas();
    const [ppO2, setPpO2] = useState(1.4);
    const [depth, setDepth] = useState(32);
    const [mix, setMix] = useState(33);

    const changePPO2 = (event: SelectChangeEvent) => {
        const value = parseFloat(event.target.value);
        setPpO2(value)
        setMix(calcBestMixNitrox(value, depth))
    }

    const changeDepth = (event: SelectChangeEvent) => {
        const value = parseInt(event.target.value);
        setDepth(value)
        setMix(calcBestMixNitrox(ppO2, value));
    }

    // @ts-ignore
    return (
        <>
            <Typography variant="h6" sx={{mt: 1, mb: 1}}>Best Mix Nitrox</Typography>
            <Typography variant="h6">EAN <Box component="span" sx={{border: '1px solid grey', p: 1}}>{mix.toFixed(0)}</Box></Typography>
            <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                <InputLabel id="ppO2">ppO2</InputLabel>
                <Select
                    labelId="ppO2"
                    id="ppO2"
                    value={ppO2.toFixed(1)}
                    label="ppO2"
                    onChange={changePPO2}
                >
                    <MenuItem key={1.2} value={1.2}>{1.2}</MenuItem>
                    <MenuItem key={1.3} value={1.3}>{1.3}</MenuItem>
                    <MenuItem key={1.4} value={1.4}>{1.4}</MenuItem>
                    <MenuItem key={1.5} value={1.5}>{1.5}</MenuItem>
                    <MenuItem key={1.6} value={1.6}>{1.6}</MenuItem>
                </Select>
            </FormControl>
            <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                <InputLabel id="depth">Depth</InputLabel>
                <Select
                    labelId="depth"
                    id="depth"
                    value={depth.toFixed(0)}
                    label="depth"
                    onChange={changeDepth}
                >
                    {[...Array(40)].map((x, i: number) => (
                        <MenuItem key={'depth-'+ i} value={1 + i}>{1 + i}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}